import React, { useEffect, useState } from 'react';
import {IProps} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import Loading from '@components/Loading';

const Spinner:React.FC<IProps> = () => {  
  return (
    <S.Root>
        <Loading 
          id={"loading-designs"}
          containerStyle={{justifyContent: 'center'}}
        />
    </S.Root>
  );
}

export default Spinner;